export default [
  {
    path: '/main/activestypes',
    meta: {
      tag: 'list_activetype',
      name: 'Tipos de Ativos',
      breadcrumb: 'Tipos de Ativos'
    },
    component: () => import(/* webpackChunkName: "activestypes-list" */ '@/views/main/settings/stock-registers/activestype/Index.vue'),
    children: [
      {
        path: '',
        name: 'listactivestypes',
        meta: {
          tag: 'list_activetype',
          menu: 'settings',
          name: 'Tipos de Ativos'
        },
        component: () => import(/* webpackChunkName: "activestypes-list" */ '@/views/main/settings/stock-registers/activestype/List.vue')
      },
      {
        path: '/main/activestype/add',
        name: 'addactivestype',
        meta: {
          tag: 'add_activetype',
          menu: 'settings',
          name: 'Adicionar | Tipo de Ativo',
          breadcrumb: 'Adicionar Tipo de Ativo'
        },
        component: () => import(/* webpackChunkName: "activestype-add" */ '@/views/main/settings/stock-registers/activestype/Add.vue')
      },
      {
        path: '/main/activestype/:id',
        name: 'editactivestype',
        meta: {
          tag: 'edit_activetype',
          menu: 'settings',
          name: 'Editar | Tipo de Ativo',
          breadcrumb: 'Editar Tipo de Ativo'
        },
        component: () => import(/* webpackChunkName: "activestype-edit" */ '@/views/main/settings/stock-registers/activestype/Edit.vue')
      }
    ]
  },
]